import { useCallback } from 'react';
import { useFetcher } from 'react-router';

import { useBloomBasename } from '@jane/bloom/hooks/useBloomBasename';
import type { Payload } from '@jane/bloom/routes/_menu.$basename.signup/types';
import type { LoginUserResponse } from '@jane/bloom/types/actions/auth';
import { buildFormData } from '@jane/bloom/utils/formData';

export const useSignup = () => {
  const basename = useBloomBasename();
  const fetcher = useFetcher<LoginUserResponse>({
    key: 'user-signup',
  });

  const signup = useCallback(
    (args: Payload) => {
      return fetcher.submit(buildFormData(args), {
        action: `${basename}signup`,
        method: 'post',
        preventScrollReset: true,
      });
    },
    [basename, fetcher]
  );

  return {
    fetcher,
    signup,
  };
};
